const ApplicantResponseModel = {
  applicant: ["hasOne", "applicant"],
}

export default ApplicantResponseModel
